/** 共通：PROFFIT SEARCHの初回表示 */
export const POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW = 'TYPE_PROFFIT_SEARCH_FIRST_VIEW';
/** クライアント：案件リプレースのポップアップ表示（2022/06/01 提案募集の機能追加） */
export const POPUP_TYPE_CLIENT_RFP_REPLACE = 'TYPE_CLIENT_RFP_REPLACE';
/** コンサルタント：案件リプレースのポップアップ表示 */
export const POPUP_TYPE_PROFESSIONAL_RFP_REPLACE = 'TYPE_PROFESSIONAL_RFP_REPLACE';
/** コンサルタント：案件リプレースのポップアップ表示（2022/06/01 提案機能と料金プラン変更） */
export const POPUP_TYPE_PROFESSIONAL_RFP_REPLACE_V2 = 'TYPE_PROFESSIONAL_RFP_REPLACE_V2';
/** クライアント: ホットライン利用規約同意 */
export const POPUP_TYPE_CLIENT_HOTLINE_TERM_AGREEMENT = 'TYPE_CLIENT_HOTLINE_TERM_AGREEMENT';
/** コンサルタント: ホットライン利用規約同意 */
export const POPUP_TYPE_PROFESSIONAL_HOTLINE_TERM_AGREEMENT = 'TYPE_PROFESSIONAL_HOTLINE_TERM_AGREEMENT';
